import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../Loader';
import MediaError from '../../../assets/images/media_error.jpg';

import './index.sass';

class ProductImage extends React.Component {
	state = {
		loading: true,
	};

	componentDidUpdate(prevProps) {
		if (prevProps.src !== this.props.src && !this.state.loading) {
			this.setState({ loading: true });
		}
	}

	render() {
		const { className, src, alt, type } = this.props;
		const { loading } = this.state;

		return (
			<>
				{loading && <Loader size={type === 'thumb' ? 'small' : 'medium'} />}
				<img
					className={`ProductImage ProductImage--${type} ${className} ${loading ? 'ProductImage--loading' : ''}`}
					src={src}
					alt={alt}
					draggable={false}
					onLoad={() => this.setState({ loading: false })}
					onError={({ currentTarget }) => {
						this.setState({ loading: false });
						currentTarget.onerror = null;
						currentTarget.src = MediaError;
					}}
				/>
			</>
		);
	}
}

ProductImage.propTypes = {
	className: PropTypes.string,
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
	type: PropTypes.oneOf(['thumb', 'large']),
};

ProductImage.defaultProps = {
	className: '',
	alt: 'Product image',
	type: 'thumb',
};

export default ProductImage;
